{
  "version": "396527fff91bfcdccf7fa21698e6f8a49432203f",
  "builtAtIso": "2026-11-05T12:04:20.581Z"
}
